import { PreferenceCpvTableau } from './../model/preference-cpv';
import { first, map, takeUntil } from 'rxjs/operators';
import { PreferenceMessages } from './../../../shared/models/component-messages/preference-messages';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { PreferencesService } from '../services/preferences.service';
import { Subject } from 'rxjs';
import { InformationComponent } from '../../../shared/modals/information/information.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Route, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthorizationService } from '../../../../authorization/services/authorization.service';
import { EnumMicroDroits } from '../../../administration/models/micro.droits';

@Component({
  selector: 'app-preferences-liste-cpv',
  templateUrl: './preferences-liste-cpv.component.html',
  styleUrls: ['./preferences-liste-cpv.component.scss']
})
export class PreferencesListeCpvComponent implements OnInit, OnDestroy {

  public preferenceMessages = new PreferenceMessages();

  private unsubscribe$ = new Subject<void>();

  cpvTableau: PreferenceCpvTableau[] = [];

  cpvListLinkLabel = '';
  cpvListUrl = '';
  isGestionComptesAnnonceur: boolean;

  constructor(private preferenceService: PreferencesService, private modalService: NgbModal, private router: Router, private translateService: TranslateService,
    private authorizationService: AuthorizationService) { }

  ngOnInit(): void {
    this.getPref();
    this.cpvListLinkLabel = this.translateService.instant('preference.tab_2.cpv_list_link_label');
    this.cpvListUrl = this.translateService.instant('preference.tab_2.cpv_list_url');
    this.habilitations();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  createList(): void {
    this.router.navigate([location.pathname + '/pref-cpv']);
  }

  getPref(): void {
    this.preferenceService.getFullCpv().pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          this.cpvTableau = [];
          const maxVal: number = 1000;
          data.forEach(el => {
            const cpvTab = new PreferenceCpvTableau();
            cpvTab.id = el.id;
            cpvTab.titre = el.titre;
            cpvTab.compteur = el.content.values.length;
            let values: string[] = new Array();
            for (let index = 0; index < el.content.values.length; index++) {
              const val = el.content.values[index];
              if (index < maxVal) {
                values.push(val.code + " - " + this.translateService.instant(val.value));
              }
              if (index === maxVal) {
                values.push("...");
              }
            }
            cpvTab.values = values;
            this.cpvTableau?.push(cpvTab);
          })
        })
      });
  }

  update(item: PreferenceCpvTableau): void {
    this.router.navigate([location.pathname + '/pref-cpv/' + item.id]);
  }

  delete(item: PreferenceCpvTableau): void {

    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.content = this.preferenceMessages.modal_delete_text;
    modalRef.componentInstance.OkOuRetour = true;
    modalRef.dismissed.pipe(map((reason: boolean) => {
      return reason;
    }))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((reason) => {
          if (reason) {
            this.preferenceService.deleteCpv(item.id)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe({
                next: (() => {
                  this.getPref();
                })
              });
          }
        })
      })
  }

  get sortList() {
    return this.cpvTableau.sort((a, b) => {
      return <any>new Date(b.dateCreation) - <any>new Date(a.dateCreation);
    });
  }

  private habilitations() {
    this.authorizationService.hasAnyMicroRightIn([EnumMicroDroits.COMPTES_ANNONCEURS_GESTION])
      .pipe(first())
      .subscribe(isGestionComptesAnnonceur => { this.isGestionComptesAnnonceur = isGestionComptesAnnonceur });
  }

}
